import {
  AuthConfiguration,
  AuthContext,
  useAuth,
  useAutoCookieFlow,
} from "@noom/hive-auth";
import React, { ReactNode } from "react";
import { appConfig } from "./config";
import { NoomLoader } from "./components/noom-loader/NoomLoader";
import { useOnce } from "./hooks/lifecycle";
import { getInAppAutoCookie } from "./utils/authCookieParser";

const authConfig: AuthConfiguration = {
  storage: "cookie",
  identityServer: {
    serverUrl: appConfig.IDENTITY_SERVER_URL,
    clientId: "buyflow-client",
    scope: "COACH_USER",
  },
  autoCookie: {
    autoCookieName: getInAppAutoCookie() ? "autologin_data" : "identity_data",
  },
};

function AutoCookieGuard({ children }: { children: ReactNode }) {
  const { isAvailable, inProgress, login, error } = useAutoCookieFlow();
  const { isAuthenticated } = useAuth();

  useOnce(() => {
    if (!isAuthenticated && isAvailable && !inProgress && !error) {
      login(window.location.href);
    }
  });

  const shouldShowLoader = !isAuthenticated && isAvailable && !error;
  if (shouldShowLoader) {
    return <NoomLoader fullScreen />;
  }
  return <>{children}</>;
}

export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <AuthContext config={authConfig}>
      <AutoCookieGuard>{children}</AutoCookieGuard>
    </AuthContext>
  );
}
